import { ErrorContainer, formatDate, sizing } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { fetchProtocol } from '../../redux/actions';
import { TabLinks } from '../presentational';
import { ProtocolHeader } from './ProtocolHeader';

export const ProtocolTabLayoutProps = {
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    params: PropTypes.shape({}),
    path: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  requestData: PropTypes.shape({
    account: PropTypes.shape({ id: PropTypes.number }),
    token: PropTypes.string,
  }).isRequired,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      exact: PropTypes.bool,
      name: PropTypes.string,
      path: PropTypes.string,
    }),
  ).isRequired,
};

export function ProtocolTabLayout(props) {
  const { children, match, routes } = props;

  // HOOKS
  const { study_protocol_id: studyProtocolId } = useParams();
  const dispatch = useDispatch();
  // Store
  const { data: studyProtocol, error, loading } = useSelector((state) => state.protocolReducer.protocol);

  if (error) {
    return (
      <>
        <TabLinks links={routes} match={match} />
        <Container>
          <ErrorContainer error={error} retry={() => dispatch(fetchProtocol(studyProtocolId))} />
        </Container>
      </>
    );
  }

  return (
    <>
      <TabLinks links={routes} match={match} />
      <Container>
        <ProtocolHeader
          header={studyProtocol?.name}
          loading={loading}
          subHeader={loading ? '' : formatDate(studyProtocol.issueDate)}
          withButton
        />
        {children}
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizing.medium};

  padding: ${sizing.xlarge};
  margin-bottom: ${sizing.xxlarge};
`;

ProtocolTabLayout.propTypes = {
  ...ProtocolTabLayoutProps.match,
  ...ProtocolTabLayoutProps.routes,
};

export default ProtocolTabLayout;
